<template>
    <input type="checkbox" id="monitor_others"  v-model="monitor">&nbsp;{{ $trans.get('__JSON__.view all') }} <span v-if="monitor">&nbsp;</span>
    <!-- ({{ view_all_count }}) -->
</template>

<script>
import axios from "axios";

export default {
    setup() {
    },
    name: "ViewAll",
    emits: ['changed'],
    created() {
        this.monitor = this.monitor_others;
        console.log(this.monitor_others);
    },
    props: {
        reload: Boolean,
        monitor_others: Boolean,
       //view_all_count: Number
    },
    data() {
        return {
            monitor: false
        };
    },
    watch: {
        monitor(newValue, oldValue) {
            if (this.reload && this.monitor_others != this.monitor) {
                let url = new URL(window.location.href);
                url.searchParams.set('view_all', this.monitor ? '1' : '0');
                window.location.href = url.toString();
            } else {
                this.$emit('changed', this.monitor);
            }
        }
    },
    computed: {
    },
    mounted() {
    },
    methods: {
    }
};
</script>

<style></style>
